const Mach = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="600"
      height="149.851"
      version="1.1"
      viewBox="0 0 600 149.851"
    >
      <defs>
        <linearGradient
          id="linearGradient-1"
          x1="0.036"
          x2="1"
          y1="0.036"
          y2="1"
        >
          <stop offset="0%" stopColor="#6B00AA"></stop>
          <stop offset="100%" stopColor="#5582FF"></stop>
        </linearGradient>
        <linearGradient
          id="linearGradient4497"
          x1="9.117"
          x2="253.614"
          y1="9.117"
          y2="253.614"
          gradientTransform="scale(2.11345 .47316)"
          gradientUnits="userSpaceOnUse"
          xlinkHref="#linearGradient-1"
        ></linearGradient>
        <linearGradient
          id="linearGradient4499"
          x1="9.117"
          x2="253.614"
          y1="9.117"
          y2="253.614"
          gradientTransform="scale(2.11345 .47316)"
          gradientUnits="userSpaceOnUse"
          xlinkHref="#linearGradient-1"
        ></linearGradient>
      </defs>
      <g
        fill="none"
        fillRule="evenodd"
        stroke="none"
        strokeWidth="1"
        transform="matrix(1.08209 0 0 1.08209 10 10)"
      >
        <g fill="url(#linearGradient4499)">
          <path
            fill="url(#linearGradient4497)"
            d="M104.702.678a10.018 10.018 0 016.22-.337c2.162.614 3.906 1.808 5.235 3.58 1.33 1.724 1.992 3.694 1.992 5.912v100.052c0 2.717-.97 5.023-2.907 6.914-1.877 1.937-4.178 2.915-6.887 2.915-2.715 0-5.042-.978-6.98-2.915-1.931-1.89-2.902-4.197-2.902-6.914v-64.76S67.084 97.05 66.96 97.249c-.907 1.499-2.328 2.537-3.901 3.256a9.426 9.426 0 01-3.98.877 9.452 9.452 0 01-3.988-.877c-1.57-.72-3.005-1.725-3.897-3.247L19.681 45.126v64.76c0 2.716-.966 5.022-2.908 6.913-1.937 1.937-4.264 2.915-6.97 2.915-2.718 0-5.014-.978-6.896-2.915C.971 114.91 0 112.602 0 109.885V9.833C0 7.615.662 5.645 1.992 3.92 3.322 2.15 5.07.955 7.227.341A10.453 10.453 0 019.84 0c1.215 0 2.416.221 3.612.678 2.047.83 3.657 2.186 4.816 4.082L59.08 72.356 99.881 4.76c1.164-1.896 2.774-3.252 4.82-4.082zm95.244 4.953C201.106 3.187 203.194 0 208.862 0c5.139 0 7.76 3.187 8.925 5.631l47.14 100.057c1.17 2.45 1.293 4.963.383 7.546-.911 2.583-2.586 4.46-5.024 5.631-2.434 1.167-4.936 1.292-7.508.383-2.572-.918-4.444-2.601-5.608-5.046L208.867 32.94l-38.313 81.262c-1.164 2.445-3.027 4.128-5.599 5.046-2.576.909-5.083.784-7.517-.383-2.438-1.171-4.113-3.048-5.024-5.631-.91-2.583-.782-5.097.382-7.546zM311.88 17.55C323.574 5.85 337.628 0 354.056 0c15.421 0 28.84 5.203 40.254 15.621 2.006 1.845 3.064 4.138 3.175 6.886.105 2.745-.75 5.12-2.595 7.14-1.831 2.066-4.113 3.16-6.846 3.275-2.728.106-5.092-.761-7.098-2.606-7.572-6.946-16.53-10.414-26.89-10.414-10.967 0-20.352 3.915-28.145 11.756-7.794 7.836-11.69 17.268-11.69 28.296 0 11.12 3.896 20.547 11.69 28.388 7.793 7.836 17.178 11.752 28.145 11.752 10.36 0 19.318-3.464 26.89-10.415 2.006-1.84 4.37-2.712 7.098-2.596 2.733.11 5.015 1.199 6.846 3.27 1.845 2.025 2.7 4.395 2.595 7.14-.11 2.744-1.169 5.04-3.175 6.886C382.897 114.793 369.477 120 354.056 120c-16.428 0-30.482-5.848-42.177-17.55-11.634-11.756-17.45-25.892-17.45-42.408 0-16.6 5.816-30.736 17.45-42.493zM519.397 2.878C521.307.959 523.593 0 526.265 0c2.669 0 4.96.96 6.869 2.878 1.91 1.923 2.866 4.23 2.866 6.918v100.408c0 2.689-.957 5-2.866 6.913-1.91 1.924-4.2 2.883-6.869 2.883-2.672 0-4.959-.96-6.868-2.883-1.914-1.914-2.862-4.224-2.862-6.913V70.788h-60.11v39.416c0 2.689-.929 5-2.778 6.913-1.91 1.924-4.2 2.883-6.868 2.883-2.678 0-4.964-.96-6.869-2.883-1.91-1.914-2.866-4.224-2.866-6.913V9.796c0-2.689.957-4.995 2.866-6.918C441.815.959 444.101 0 446.78 0c2.668 0 4.959.96 6.868 2.878 1.85 1.923 2.779 4.23 2.779 6.918v41.482h60.11V9.796c0-2.689.947-4.995 2.86-6.918z"
          ></path>
        </g>
      </g>
    </svg>
  );
}

export default Mach;
